import { EDHPPalleteImage, EuroPalletImage, HalfPalletImage, PlasticPalletImage } from 'assets';

export const palletImages = {
   EDHP_PALLET: EDHPPalleteImage,
   EURO_PALLET: EuroPalletImage,
   HALF_PALLET_NDHP: HalfPalletImage,
   QUARTER_PALLET_CDHP: PlasticPalletImage,
};
